<app-dialog-header [title]="'FORM.SELECT_USERS.TITLE'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" fxLayout="column" fxLayoutAlign="start">
    <div class="search-input-wrapper" fxFlex="1 0 auto" fxLayout="column" fxLayoutAlign="start center">
        <mat-form-field floatLabel="never" fxFlex="1 0 auto">
            <input
                matInput
                id="search"
                test-id="select-users-dialog-input"
                [placeholder]="'FORM.SELECT_USERS.FIELD.SEARCH' | translate"
                aria-label="Search Person"
                [matAutocomplete]="auto"
                [formControl]="searchInput"
            />
            <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let user of entitie$ | async | exclude: list:'id'" [value]="user.fullName" (onSelectionChange)="addToList(user)">
                    <div fxLayout="row" fxLayoutAlign="flex-start center">
                        <img class="avatar" *ngIf="user.avatar.src; else initials" [alt]="user.fullName" [src]="user.avatar.src" />
                        <ng-template #initials>
                            <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                        </ng-template>
                        <span>{{ user.fullName }}</span>
                    </div>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>

    <mat-card appearance="outlined" *ngIf="list.length !== 0">
        <mat-list>
            <mat-list-item *ngFor="let user of list; let i = index">
                <div fxLayout="row" fxLayoutAlign="flex-start center">
                    <img class="avatar" *ngIf="user.avatar.src; else initials" [alt]="user.fullName" [src]="user.avatar.src" />
                    <ng-template #initials>
                        <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                    </ng-template>
                    <span>{{ user.fullName }}</span>
                </div>
                <mat-icon class="close" (click)="removeFromList(i)">close</mat-icon>
            </mat-list-item>
        </mat-list>
    </mat-card>
</div>
<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>
    <app-flat-button [label]="'FORM.SELECT_USERS.BUTTON.SAVE'" (onClick)="saveSelected()"></app-flat-button>
</div>
